module.exports = __webpack_public_path__ + "static/img/5-3.1570805.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-5/5-3.jpg
// module id = 745
// module chunks = 1